import styled from 'styled-components';

import {
	Button,
	fontSize,
	FontSizes,
	fontWeight,
	FontWeights,
	minWidth,
	Text,
	TextButton,
	TextElements,
} from '@calm-web/design-system';

import { ContentWrapper } from '@/components/b2b/shared/styles';

export const Description = styled.div`
	margin-top: 12px;
`;

export const SubmitButton = styled(Button)`
	width: 100%;
	min-width: 200px;
	margin: 16px auto;

	${minWidth('tablet')} {
		width: auto;
	}
`;

export const Help = styled.div`
	margin: 8px auto;
	width: 100%;
	text-align: left;
	${fontSize(FontSizes.base)}
	${fontWeight(FontWeights.Medium)};
`;

export const Legal = styled.div`
	font-style: italic;
	${fontSize(FontSizes.sm)};
`;

export const EligibilityContentWrapper = styled(ContentWrapper)`
	width: 100%;
`;

export const CtaText = styled(Text).attrs({
	el: TextElements.H5,
	weight: FontWeights.Medium,
})`
	margin-top: 16px;
`;

export const AccessButton = styled(TextButton)`
	${fontSize(FontSizes.sm)}
`;
